import { useState, useEffect } from 'react';
import {
  Box, Button, Slider, Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { getCalculatorData } from '../../api/services';
import i18n from '../common/i18n';
import moneyFormatterWithoutDecimals from '../common/FormatterUtil';
import matrixResponse from './matrixResponse.json';
import '../../assests/css/wtStyle.css';
import underline from '../../assests/images/wt/underline.svg';
import {
  PERSONAL_ADWORDS_LOAN_URL, getEnv,
} from '../../api/env';

const WtCalculator = () => {
  const ORIGINACION_WT_LINK = getEnv(PERSONAL_ADWORDS_LOAN_URL);

  const StyledSlider = styled(Slider)({
    // Estilo para ocultar las marcas
    '& .MuiSlider-mark': {
      display: 'none', // Oculta las marcas
    },
  });

  const [amounts, setAmounts] = useState(undefined);
  const [matrix, setMatrix] = useState(undefined);
  const [terms, setTerms] = useState(undefined);
  const [value, setValue] = useState(undefined);
  const [installmentAmountSelected, setInstallmentAmountSelected] = useState(undefined);
  const [termsLastListSelected, setTermsLastListSelected] = useState(undefined);

  function getPaymentDate() {
    const dateNow = new Date();
    const day = dateNow.getDate();
    let plusMonth = 1;
    if (day >= 21) {
      plusMonth += 1;
    }
    dateNow.setDate(1);
    dateNow.setMonth(dateNow.getMonth() + plusMonth);
    const dueMonth = dateNow.toLocaleString('es-ES', { month: 'long' });
    return `6 de ${dueMonth.toUpperCase()}`;
  }

  const pushEvent = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: {
        items: [{
          item_name: 'Tradicional Web',
        }],
      },
    });
  };

  const handleChange = (amountsAux, matrixAux, termsAux, amountSelectedIndexPosition) => {
    const installmentsAmountListAux = matrixAux[amountSelectedIndexPosition];
    const termsListAux = termsAux[amountSelectedIndexPosition];
    const amountAux = amountsAux[amountSelectedIndexPosition];
    setInstallmentAmountSelected(installmentsAmountListAux[installmentsAmountListAux.length - 1]);
    setTermsLastListSelected(termsListAux[termsListAux.length - 1]);
    setValue(amountAux);
  };

  const getCalculator = async () => {
    try {
      const { data } = await getCalculatorData();
      setAmounts(data.amounts);
      setMatrix(data.matrix);
      setTerms(data.terms);
      const amountAux = data.amounts[Math.round((data.amounts && data.amounts.length - 1) / 2)];
      handleChange(data.amounts, data.matrix, data.terms, data.amounts.indexOf(amountAux));
    } catch (error) {
      console.error('There was an error!', error);
      setAmounts(matrixResponse.amounts);
      setMatrix(matrixResponse.matrix);
      setTerms(matrixResponse.terms);
    }
  };

  useEffect(() => {
    getCalculator();
  }, []);

  return (
    <Box className="resultsCalculator">
      <Box className="boxResultsCalculator">
        {
          value !== undefined && (
            <>
              <Box className="boxSlider">
                <Typography variant="h5" fontWeight={500} className="contentBoxSlider">
                  {i18n.wtHowMany}
                </Typography>
                <Typography variant="h3" fontWeight={700} className="contentBoxSlider">
                  {moneyFormatterWithoutDecimals.format(value)}
                </Typography>
                <StyledSlider
                  className="slider"
                  aria-label={i18n.wtCalculator}
                  style={{ color: '#DA0067' }}
                  onChange={(e, item) => { handleChange(amounts, matrix, terms, amounts.indexOf(item)); }}
                  value={value}
                  step={null}
                  marks={amounts.map((val) => ({ value: val }))}
                  min={Math.min(...amounts)}
                  max={Math.max(...amounts)}
                />
              </Box>
              <Typography variant="p" className="pCalculator pAlign">{i18n.wtPriceFrom}</Typography>
              <Typography variant="h5" fontWeight={700}>
                {moneyFormatterWithoutDecimals.format(installmentAmountSelected)}
              </Typography>
              <img src={underline} alt="underline" />
              <Box className="lineResults">
                <Typography variant="p" className="pCalculator">{i18n.wtQuantity}</Typography>
                <Typography variant="h6" className="resultMargin">{termsLastListSelected}</Typography>
              </Box>
              <hr />
              <Box className="lineResults">
                <Typography variant="p" className="pCalculator">{i18n.wtFirstExpiration}</Typography>
                <Typography variant="h6" className="resultMargin">{getPaymentDate()}</Typography>
              </Box>
              <a
                href={ORIGINACION_WT_LINK}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Button onClick={pushEvent} variant="contained" className="ButtonMagenta buttonCredit">
                  {i18n.wtButtonCredit}
                </Button>
              </a>
              <Box mt={0.75}>
                <Typography variant="subtitle2">{i18n.wtLegal}</Typography>
              </Box>
            </>
          )
  }
      </Box>
    </Box>
  );
};

export default WtCalculator;
